<ngx-slick-carousel class="carousel carouselUsedHome" #carouselUsedHome="slick-carousel" [config]="slideConfig">
  @for (category of usedCategories(); track category.id) {
  <div ngxSlickItem data-aos="fade-up" class="slide usedCategoryHome" (click)="goToDetail(category)">
    <div class="contentImage">
      <img [ngSrc]="category.image.image" [alt]="category.image.alt" fill />
    </div>
    <a class="titleUsed" [routerLink]="'/equipo-usado/categorias/' + category.category.slug + '/' + category.slug"
      ><h3>{{ category.name | uppercase }}</h3></a
    >
    <div class="hoverData">
      <h3>{{ category.name | uppercase }}</h3>
      <p>{{ category.description }}</p>
      <div class="viewDetail">VER EQUIPOS</div>
    </div>
  </div>
  }
</ngx-slick-carousel>
